import { constants, typographyStyles } from "@newsela/angelou";

const {
  colors: { ui },
} = constants;
const { textSObj } = typographyStyles;

export const buttonCss = {
  ...textSObj,
  marginBottom: "12px",
  padding: "16px 19px",
  justifyContent: "flex-start",
  columnGap: "16px",
  textAlign: "left",
  color: ui.neutral[600],
  borderRadius: "12px",

  ":hover": {
    textDecoration: "underline",
  },
};

export const iconCss = {
  marginTop: "3px",
  width: "24px",
  height: "24px",

  path: {
    strokeWidth: "3px",
  },
};
